/**
 * The first-time wizard (/welcome). Farmers, shopkeepers and offtakers give
 * their area (state and local government area); farmers also say which
 * cluster or association they belong to, and what they produce.
 * Distributors, who cover more ground, give their coverage instead:
 * country, regions and states (PR 73); offtakers give where they buy:
 * countries, states and local areas (PR 75). Every step is required, so until
 * it is finished the app opens the wizard instead of the dashboard.
 */
import { coverageComplete } from '@/components/CoverageFields';

export function isFarmer(user) {
  return user?.user_type === 'farmer';
}

export function isDistributor(user) {
  return user?.user_type === 'distributor';
}

export function hasArea(user) {
  return Boolean(user?.state && user?.lga);
}

export function userCoverage(user) {
  // user.data.coverage: saved by the profile before PR 73's fix.
  const cov = user?.coverage || user?.data?.coverage || {};
  return { country: cov.country || 'NG', regions: cov.regions || [], states: cov.states || [] };
}

export function hasCoverage(user) {
  return Boolean((user?.coverage || user?.data?.coverage)?.country) && coverageComplete(userCoverage(user));
}

export function isOfftaker(user) {
  return user?.user_type === 'offtaker';
}

/** Where an offtaker buys (PR 75): at least one country, and for Nigeria
 * at least one state. */
export function hasBuyingArea(user) {
  const area = user?.buying_area;
  if (!area?.countries?.length) return false;
  return !area.countries.includes('NG') || area.states?.length > 0;
}

export function hasGroups(user) {
  return Boolean(user?.cluster_id || user?.associations?.length || user?.not_member);
}

export function needsWelcome(user) {
  if (!user) return false;
  if (isDistributor(user)) return !hasCoverage(user);
  if (isOfftaker(user)) return !hasBuyingArea(user);
  if (!hasArea(user)) return true;
  return isFarmer(user) && !user.onboarding_done;
}
